export const BUSINESSAPPLICATIONS_FILE = 'BUSINESSAPPLICATIONS_FILE';
// 更新
export const BUSINESSAPPLICATIONS_UPDATE = 'BUSINESSAPPLICATIONS_UPDATE';
